import { Match, Signal, Switch, createEffect } from "solid-js";
import styles from './st-input.module.css';
import { JSX } from "solid-js/web/types/jsx";

export class InputParams {
    placeholder?: string;
    value!: Signal<string>;
    label?: string
    type?: 'password' | 'number'
    onEnterKey?: () => void;
    icon? : string = undefined;
    selected? = false;
    focused? = false;
    required? = false;
    disabled?= false;
    defaultInput?: () => void = undefined;
}

export default function STInput(props: InputParams & JSX.HTMLAttributes<HTMLInputElement>) {
    function ref(el: HTMLInputElement) {
        createEffect(() => {
            const focused = props.focused;
            const selected = props.selected;

            if (focused) {
                requestAnimationFrame(() => {
                    el?.focus();
                })
            }
            else {
                el?.blur();
            }

            if (selected) {
                el?.select();
            }
        }) 

        if (props.ref && typeof props.ref === 'function') {
            props.ref(el);
        }
    }

    return (
        <label class={`flexbox`}>
            <span>{props.label}</span>
            <div class={styles['input-container']}>
                <input
                    use:defaultInput={props.defaultInput}
                    disabled={props.disabled}
                    class={`${styles['st-input']} auto`}
                    ref={ref}
                    type={props.type}
                    value={props.value[0]()}
                    onKeyDown={handleKeyDown}
                    onInput={onInput}
                    onFocusOut={props.onFocusOut}
                    placeholder={props.placeholder ?? " "}
                    onBlur={props.onBlur}
                    style={props.style}
                    required={props.required}
                    size="1"
                    data-has-icon={!!props.icon}
                />
                <span class={`${styles['icon']} ${props.icon}`} role="presentation"></span>
            </div>
        </label>
    )

    function onInput(this: HTMLInputElement, e: Event) {
        props.value[1](this.value);
    }

    function handleKeyDown(this: HTMLInputElement, ev: KeyboardEvent) {
        if (ev.key === 'Enter' && props.onEnterKey) {
            props.onEnterKey();
        }
    }
}

STInput.defaultProps = new InputParams();
